import {
  DEFAULT_WAITER_PERMISSIONS,
  mapWaiterPermissionsToBranchPermissions,
} from "./waiterPermissions";

export const MOZZO_MODULE_DEFINITIONS = Object.freeze([
  {
    key: "inicio",
    label: "Inicio",
    description: "Pulso operativo de la sucursal y seguimiento de pedidos.",
  },
  {
    key: "cocina",
    label: "Cocina",
    description: "Toma, prepara y entrega pedidos desde la cocina.",
  },
  {
    key: "mozos",
    label: "Mozos",
    description: "Administracion del equipo de salon y alertas del boton mozo.",
  },
  {
    key: "personal",
    label: "Personal",
    description:
      "Jerarquia, equipo por sucursal, solicitudes y estado operativo del personal.",
  },
  {
    key: "mozo",
    label: "Panel mozo",
    description: "Operacion diaria del mozo dentro de una sucursal.",
  },
  {
    key: "menu",
    label: "Menu",
    description: "Productos, categorias, subcategorias y combinaciones guiadas.",
  },
  {
    key: "promos",
    label: "Promos",
    description: "Combos, promociones y reglas comerciales.",
  },
  {
    key: "pedidos",
    label: "Pedidos",
    description: "Pedidos externos, clientes, delivery, retiro y canales de venta.",
  },
  {
    key: "ingredientes",
    label: "Ingredientes",
    description: "Ingredientes base, fotos y configuracion de extras.",
  },
  {
    key: "stock",
    label: "Stock",
    description: "Control de stock, consumos y disponibilidad de venta.",
  },
  {
    key: "qr",
    label: "Menu QR",
    description: "Mesas QR, sesiones publicas y configuracion de carta.",
  },
  {
    key: "pagos",
    label: "Caja",
    description: "Cobros, conciliacion, deuda y comisiones de la sucursal.",
  },
  {
    key: "estadisticas",
    label: "Estadisticas",
    description: "Resumen economico y evolucion del negocio.",
  },
  {
    key: "restaurante",
    label: "Mi Restaurante",
    description: "Datos visibles, horarios y configuracion operativa de la sucursal.",
  },
  {
    key: "configuracion",
    label: "Configuracion",
    description: "Usuarios, permisos, sucursales y acceso administrativo.",
  },
  {
    key: "backoffice",
    label: "Backoffice",
    description: "Control plataforma, empresas, billetera MZ y auditoria global.",
  },
  {
    key: "acceso",
    label: "Seleccion de acceso",
    description: "Entrada por contexto: global, sucursal, cocina o mozo.",
  },
]);

export const MOZZO_ACCESS_ROLE_DEFINITIONS = Object.freeze([
  {
    key: "creator",
    label: "Creador local",
    description: "Modo desarrollo con acceso total.",
  },
  {
    key: "platform_backoffice",
    label: "Admin plataforma",
    description: "Opera el backoffice general de MozzoApp.",
  },
  {
    key: "admin_general_global",
    label: "Admin general global",
    description: "Gestiona empresa completa y selecciona sucursales.",
  },
  {
    key: "admin_general_branch",
    label: "Admin general por sucursal",
    description: "Opera una sucursal puntual con acceso amplio.",
  },
  {
    key: "encargado_sucursal",
    label: "Encargado de sucursal",
    description:
      "Coordina el equipo de una sucursal y eleva altas o bajas para aprobacion del admin general.",
  },
  {
    key: "soporte_mozzo",
    label: "Soporte Mozzo",
    description: "Acceso operativo asistido para soporte dentro de una sucursal.",
  },
  {
    key: "caja",
    label: "Caja",
    description: "Opera cierre de cuentas y cobros dentro de la sucursal.",
  },
  {
    key: "admin_limitado",
    label: "Admin limitado",
    description: "Opera segun permisos puntuales de la sucursal.",
  },
  {
    key: "mozo",
    label: "Mozo",
    description: "Opera pedidos y servicio de salon.",
  },
  {
    key: "cocina",
    label: "Cocina",
    description: "Gestiona estados de preparacion y entrega.",
  },
]);

export const MOZZO_ACTION_DEFINITIONS = Object.freeze([
  {
    key: "apply_order_discount",
    label: "Aplicar descuento a una cuenta",
    description: "Autorizar descuentos en pesos o porcentaje antes del cobro.",
  },
  {
    key: "take_orders",
    label: "Tomar pedidos",
    description: "Crear pedidos nuevos desde salon, QR o kiosk segun contexto.",
  },
  {
    key: "modify_orders",
    label: "Modificar pedidos",
    description: "Editar platos, cantidades y observaciones.",
  },
  {
    key: "cancel_orders",
    label: "Cancelar pedidos",
    description: "Anular pedidos antes de su cierre.",
  },
  {
    key: "charge_orders",
    label: "Cobrar",
    description: "Registrar cobros manuales o integrados.",
  },
  {
    key: "refund_orders",
    label: "Devolver",
    description: "Gestionar devoluciones, anular cobros o revertir cierres.",
  },
  {
    key: "view_external_orders",
    label: "Ver pedidos externos",
    description: "Consultar pedidos de delivery, retiro, clientes y su seguimiento.",
  },
  {
    key: "create_external_orders",
    label: "Crear pedidos externos",
    description: "Tomar pedidos manuales de delivery, retiro o canales externos.",
  },
  {
    key: "edit_external_orders",
    label: "Editar pedidos externos",
    description: "Modificar productos, datos de entrega y observaciones antes de cocina.",
  },
  {
    key: "cancel_external_orders",
    label: "Cancelar pedidos externos",
    description: "Cancelar pedidos externos y dejar su motivo registrado.",
  },
  {
    key: "change_external_order_status",
    label: "Cambiar estado externo",
    description: "Confirmar, preparar, despachar y entregar pedidos externos.",
  },
  {
    key: "dispatch_external_order_to_kitchen",
    label: "Enviar pedido externo a cocina",
    description: "Proyectar un pedido externo al mismo flujo operativo de cocina.",
  },
  {
    key: "assign_external_delivery",
    label: "Asignar delivery",
    description: "Asignar repartidor y actualizar el seguimiento de entregas.",
  },
  {
    key: "view_customers",
    label: "Ver clientes",
    description: "Consultar clientes, direcciones e historial de compras externo.",
  },
  {
    key: "manage_customers",
    label: "Gestionar clientes",
    description: "Crear, editar, bloquear o archivar clientes del restaurante.",
  },
  {
    key: "export_customers",
    label: "Exportar clientes",
    description: "Exportar el listado y el historial de clientes autorizado.",
  },
  {
    key: "manage_delivery",
    label: "Gestionar delivery",
    description: "Configurar zonas, costos, tiempos y reglas de entrega.",
  },
  {
    key: "manage_whatsapp",
    label: "Configurar WhatsApp",
    description: "Preparar la integracion oficial de WhatsApp por sucursal.",
  },
  {
    key: "manage_sales_channels",
    label: "Configurar canales",
    description: "Definir disponibilidad para pedido web, chatbot y canales externos.",
  },
  {
    key: "manage_menu",
    label: "Gestionar menu",
    description: "Editar productos, recetas, precios y promos.",
  },
  {
    key: "manage_stock",
    label: "Gestionar stock",
    description: "Ajustar stock, recetas, consumos y unidades.",
  },
  {
    key: "manage_qr",
    label: "Gestionar QR",
    description: "Administrar mesas QR, sesion publica y cobro del menu QR.",
  },
  {
    key: "manage_payments",
    label: "Gestionar caja",
    description:
      "Configurar cobros, medios de pago, conciliacion, comisiones y cierres.",
  },
  {
    key: "export_reports",
    label: "Exportar reportes",
    description: "Descargar PDF, CSV y respaldos operativos segun el contexto.",
  },
  {
    key: "manage_settings",
    label: "Gestionar configuracion de sucursal",
    description:
      "Configurar identidad, horarios, modos operativos y reglas de la sucursal asignada.",
  },
  {
    key: "manage_company_settings",
    label: "Gestionar empresa",
    description:
      "Administrar datos fiscales, sucursales y configuracion general de la empresa. Solo disponible para dueno o admin general.",
  },
  {
    key: "manage_fiscal_connection",
    label: "Gestionar conexion fiscal",
    description:
      "Configurar CUIT, delegacion ARCA y puntos de venta. Solo disponible para dueno o admin general.",
  },
  {
    key: "manage_users",
    label: "Gestionar usuarios",
    description:
      "Crear, editar, activar y desactivar usuarios internos, accesos y turnos.",
  },
  {
    key: "view_personnel",
    label: "Ver personal",
    description: "Consultar la dotacion, jerarquia y estado operativo por sucursal.",
  },
  {
    key: "manage_personnel_directly",
    label: "Gestionar personal directamente",
    description:
      "Crear, editar, asignar y desactivar personal sin requerir una aprobacion previa.",
  },
  {
    key: "request_personnel_changes",
    label: "Solicitar cambios de personal",
    description:
      "Elevar altas, bajas o cambios permitidos por jerarquia para aprobacion del admin general.",
  },
  {
    key: "review_personnel_requests",
    label: "Aprobar solicitudes de personal",
    description:
      "Aprobar o rechazar solicitudes de altas, bajas y cambios iniciadas por encargados.",
  },
  {
    key: "toggle_operational_staff",
    label: "Activar o pausar personal operativo",
    description:
      "Pausar o reactivar mozos y cocina de la sucursal sin modificar sus permisos.",
  },
]);

const FULL_WAITER_BRANCH_PERMISSIONS = mapWaiterPermissionsToBranchPermissions(
  {
    takeOrders: true,
    modifyOrders: true,
    cancelOrders: true,
    chargeOrders: true,
    refundOrders: true,
  },
  DEFAULT_WAITER_PERMISSIONS
);

const DEFAULT_LIMITED_ADMIN_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: true,
  canManageMenu: true,
  canViewStock: true,
  canManageStock: true,
  canManageOrders: true,
  canManageQr: false,
  canManagePayments: false,
  canManageSettings: false,
  ...mapWaiterPermissionsToBranchPermissions(
    {
      takeOrders: true,
      modifyOrders: true,
      cancelOrders: true,
      chargeOrders: false,
      refundOrders: false,
    },
    DEFAULT_WAITER_PERMISSIONS
  ),
});

const FULL_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: true,
  canManageMenu: true,
  canViewStock: true,
  canManageStock: true,
  canManageOrders: true,
  canManageQr: true,
  canManagePayments: true,
  canManageSettings: true,
  ...FULL_WAITER_BRANCH_PERMISSIONS,
});

const KITCHEN_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: false,
  canManageMenu: false,
  canViewStock: false,
  canManageStock: false,
  canManageOrders: true,
  canManageQr: false,
  canManagePayments: false,
  canManageSettings: false,
  ...mapWaiterPermissionsToBranchPermissions(
    {
      takeOrders: false,
      modifyOrders: false,
      cancelOrders: false,
      chargeOrders: false,
      refundOrders: false,
    },
    DEFAULT_WAITER_PERMISSIONS
  ),
});

const WAITER_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: false,
  canManageMenu: false,
  canViewStock: false,
  canManageStock: false,
  canManageOrders: true,
  canManageQr: false,
  canManagePayments: false,
  canManageSettings: false,
  ...mapWaiterPermissionsToBranchPermissions(
    {
      takeOrders: true,
      modifyOrders: true,
      cancelOrders: true,
      chargeOrders: false,
      refundOrders: false,
    },
    DEFAULT_WAITER_PERMISSIONS
  ),
});

const CASHIER_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: false,
  canManageMenu: false,
  canViewStock: false,
  canManageStock: false,
  canManageOrders: true,
  canManageQr: false,
  canManagePayments: true,
  canManageSettings: false,
  ...mapWaiterPermissionsToBranchPermissions(
    {
      takeOrders: false,
      modifyOrders: false,
      cancelOrders: false,
      chargeOrders: true,
      refundOrders: true,
    },
    DEFAULT_WAITER_PERMISSIONS
  ),
});

const SUPPORT_BRANCH_PERMISSIONS = Object.freeze({
  canViewMenu: true,
  canManageMenu: false,
  canViewStock: true,
  canManageStock: false,
  canManageOrders: true,
  canManageQr: true,
  canManagePayments: false,
  canManageSettings: false,
  ...mapWaiterPermissionsToBranchPermissions(
    {
      takeOrders: false,
      modifyOrders: true,
      cancelOrders: true,
      chargeOrders: false,
      refundOrders: false,
    },
    DEFAULT_WAITER_PERMISSIONS
  ),
});

const BRANCH_MANAGER_PERMISSIONS = FULL_BRANCH_PERMISSIONS;

export const MOZZO_BRANCH_PERMISSION_GROUPS = Object.freeze([
  {
    id: "menu",
    label: "Carta e ingredientes",
    description:
      "Puede consultar la carta y los ingredientes. Gestionar habilita crear, editar y eliminar.",
    viewKey: "canViewMenu",
    manageKey: "canManageMenu",
  },
  {
    id: "stock",
    label: "Stock",
    description:
      "Puede ver existencias. Gestionar habilita cargar, ajustar y descontar manualmente.",
    viewKey: "canViewStock",
    manageKey: "canManageStock",
  },
  {
    id: "orders",
    label: "Pedidos",
    description: "Acceso operativo al seguimiento de pedidos, cocina y entregas.",
    manageKey: "canManageOrders",
  },
  {
    id: "qr",
    label: "QR",
    description: "Generacion y manejo de QR por mesa.",
    manageKey: "canManageQr",
  },
  {
    id: "payments",
    label: "Caja y cobros",
    description: "Acceso al cobro, cierre de cuentas y resumen economico.",
    manageKey: "canManagePayments",
  },
  {
    id: "settings",
    label: "Mi Restaurante",
    description:
      "Permite editar datos y configuracion operativa de la sucursal. No habilita datos fiscales ni administracion general de la empresa.",
    manageKey: "canManageSettings",
  },
]);

export const MOZZO_BRANCH_PERMISSION_KEYS = Object.freeze([
  "canViewMenu",
  "canManageMenu",
  "canViewStock",
  "canManageStock",
  "canManageOrders",
  "canManageQr",
  "canManagePayments",
  "canManageSettings",
  "waiterCanTakeOrders",
  "waiterCanModifyOrders",
  "waiterCanCancelOrders",
  "waiterCanChargeOrders",
  "waiterCanRefundOrders",
]);

export const updateMozzoBranchPermissionGroup = (
  currentPermissions,
  group,
  field,
  enabled
) => {
  if (!group?.manageKey) {
    return { ...currentPermissions };
  }

  if (field === "manageKey") {
    return {
      ...currentPermissions,
      [group.manageKey]: enabled === true,
      ...(group.viewKey && enabled === true ? { [group.viewKey]: true } : {}),
    };
  }

  if (!group.viewKey) {
    return { ...currentPermissions };
  }

  return {
    ...currentPermissions,
    [group.viewKey]: enabled === true,
    ...(enabled === true ? {} : { [group.manageKey]: false }),
  };
};

const GLOBAL_ADMIN_MODULE_KEYS = Object.freeze([
  "inicio",
  "cocina",
  "mozos",
  "personal",
  "menu",
  "promos",
  "pedidos",
  "ingredientes",
  "stock",
  "qr",
  "pagos",
  "estadisticas",
  "restaurante",
  "configuracion",
  "acceso",
]);

const BRANCH_ADMIN_GENERAL_MODULE_KEYS = Object.freeze([
  "inicio",
  "cocina",
  "mozos",
  "personal",
  "menu",
  "promos",
  "pedidos",
  "ingredientes",
  "stock",
  "qr",
  "pagos",
  "estadisticas",
  "restaurante",
  "acceso",
]);

const LIMITED_ADMIN_BASE_MODULE_KEYS = Object.freeze(["personal", "acceso"]);

const PLATFORM_BACKOFFICE_MODULE_KEYS = Object.freeze(["backoffice", "acceso"]);
const WAITER_MODULE_KEYS = Object.freeze(["mozo", "acceso"]);
const KITCHEN_MODULE_KEYS = Object.freeze(["cocina", "acceso"]);
const CASHIER_MODULE_KEYS = Object.freeze([
  "inicio",
  "pedidos",
  "pagos",
  "estadisticas",
  "acceso",
]);
const SUPPORT_MODULE_KEYS = Object.freeze([
  "inicio",
  "cocina",
  "mozos",
  "menu",
  "promos",
  "pedidos",
  "ingredientes",
  "stock",
  "qr",
  "acceso",
]);

const branchPermissionChecksByModule = Object.freeze({
  inicio: ["canManageOrders", "canManageSettings"],
  cocina: ["canManageOrders", "canManageSettings"],
  restaurante: ["canManageSettings"],
  mozos: ["canManageOrders", "canManageSettings"],
  menu: ["canViewMenu", "canManageMenu"],
  promos: ["canViewMenu", "canManageMenu"],
  pedidos: ["canManageOrders", "canManagePayments"],
  ingredientes: ["canViewMenu", "canManageMenu"],
  stock: ["canViewStock", "canManageStock"],
  qr: ["canManageQr"],
  pagos: ["canManagePayments"],
  estadisticas: ["canManagePayments"],
  configuracion: ["canManageSettings"],
});

export const MOZZO_INTERNAL_USER_ROLE_DEFINITIONS = Object.freeze([
  {
    key: "owner",
    workspaceRole: "admin_general",
    label: "Dueno",
    description: "Titular de la empresa y cuenta principal del restaurante.",
    scope: "company",
    assignable: false,
    removable: false,
    editable: false,
    modules: GLOBAL_ADMIN_MODULE_KEYS,
    branchPermissions: FULL_BRANCH_PERMISSIONS,
  },
  {
    key: "admin_general",
    workspaceRole: "admin_general",
    label: "Admin general",
    description:
      "Puede operar la empresa completa, cambiar entre sucursales y administrar usuarios.",
    scope: "company",
    assignable: true,
    removable: true,
    editable: true,
    modules: GLOBAL_ADMIN_MODULE_KEYS,
    branchPermissions: FULL_BRANCH_PERMISSIONS,
  },
  {
    key: "encargado_sucursal",
    workspaceRole: "encargado_sucursal",
    label: "Encargado de sucursal",
    description:
      "Coordina la operacion y el equipo de una sucursal. Las altas y bajas requieren aprobacion del admin general.",
    scope: "branch",
    assignable: true,
    removable: true,
    editable: true,
    modules: [],
    branchPermissions: BRANCH_MANAGER_PERMISSIONS,
    allowsCustomBranchPermissions: true,
  },
  {
    key: "admin_limitado",
    workspaceRole: "admin_limitado",
    label: "Admin limitado",
    description:
      "Opera una sucursal con permisos configurables. Es el rol flexible por defecto.",
    scope: "branch",
    assignable: true,
    removable: true,
    editable: true,
    modules: [],
    branchPermissions: DEFAULT_LIMITED_ADMIN_BRANCH_PERMISSIONS,
    allowsCustomBranchPermissions: true,
  },
  {
    key: "mozo",
    workspaceRole: "mozo",
    label: "Mozo",
    description: "Ingresa al panel de mozo y trabaja solo el flujo de salon.",
    scope: "branch",
    assignable: true,
    removable: true,
    editable: true,
    modules: WAITER_MODULE_KEYS,
    branchPermissions: WAITER_BRANCH_PERMISSIONS,
  },
  {
    key: "cocina",
    workspaceRole: "cocina",
    label: "Cocina",
    description: "Ingresa al modulo aislado de cocina y no ve el panel administrativo.",
    scope: "branch",
    assignable: true,
    removable: true,
    editable: true,
    modules: KITCHEN_MODULE_KEYS,
    branchPermissions: KITCHEN_BRANCH_PERMISSIONS,
  },
  {
    key: "caja",
    workspaceRole: "caja",
    label: "Caja",
    description:
      "Opera cobros, cierres y seguimiento economico basico desde la sucursal.",
    scope: "branch",
    assignable: false,
    legacy: true,
    removable: true,
    editable: true,
    modules: CASHIER_MODULE_KEYS,
    branchPermissions: CASHIER_BRANCH_PERMISSIONS,
  },
  {
    key: "soporte_mozzo",
    workspaceRole: "soporte_mozzo",
    label: "Soporte Mozzo",
    description:
      "Acceso operativo de soporte para revisar flujo, menu, stock y pedidos sin tocar caja ni configuracion sensible.",
    scope: "branch",
    assignable: false,
    legacy: true,
    removable: true,
    editable: true,
    modules: SUPPORT_MODULE_KEYS,
    branchPermissions: SUPPORT_BRANCH_PERMISSIONS,
  },
]);

const hasAnyBranchPermission = (hasBranchPermission, permissionKeys = []) => {
  if (typeof hasBranchPermission !== "function") {
    return false;
  }

  return permissionKeys.some((permissionKey) => hasBranchPermission(permissionKey));
};

const normalizeBooleanPermissions = (input = {}, fallback = {}) =>
  Object.keys(fallback).reduce((acc, key) => {
    acc[key] =
      input?.[key] === undefined ? Boolean(fallback[key]) : input[key] === true;
    return acc;
  }, {});

const enforcePermissionDependencies = (permissions = {}) => ({
  ...permissions,
  canViewMenu: permissions.canManageMenu === true || permissions.canViewMenu === true,
  canViewStock: permissions.canManageStock === true || permissions.canViewStock === true,
});

const ASSIGNABLE_ROLE_KEYS_BY_ACCESS_ROLE = Object.freeze({
  creator: [
    "admin_general",
    "encargado_sucursal",
    "admin_limitado",
    "mozo",
    "cocina",
  ],
  platform_backoffice: [
    "admin_general",
    "encargado_sucursal",
    "admin_limitado",
    "mozo",
    "cocina",
  ],
  admin_general_global: [
    "admin_general",
    "encargado_sucursal",
    "admin_limitado",
    "mozo",
    "cocina",
  ],
  admin_general_branch: [
    "admin_general",
    "encargado_sucursal",
    "admin_limitado",
    "mozo",
    "cocina",
  ],
  encargado_sucursal: ["admin_limitado", "mozo", "cocina"],
  admin_limitado: ["mozo", "cocina"],
});

const VISIBLE_ROLE_KEYS_BY_ACCESS_ROLE = Object.freeze({
  encargado_sucursal: ["encargado_sucursal", "admin_limitado", "mozo", "cocina"],
  admin_limitado: ["mozo", "cocina"],
});

export const getMozzoInternalUserRole = (roleKey) =>
  MOZZO_INTERNAL_USER_ROLE_DEFINITIONS.find((role) => role.key === roleKey) ||
  MOZZO_INTERNAL_USER_ROLE_DEFINITIONS.find((role) => role.key === "admin_limitado");

export const listMozzoAssignableInternalUserRoles = () =>
  MOZZO_INTERNAL_USER_ROLE_DEFINITIONS.filter((role) => role.assignable);

export const listMozzoAssignableInternalUserRolesForAccessRole = (accessRole) => {
  const allowedRoleKeys = new Set(
    ASSIGNABLE_ROLE_KEYS_BY_ACCESS_ROLE[accessRole] || []
  );

  return listMozzoAssignableInternalUserRoles().filter((role) =>
    allowedRoleKeys.has(role.key)
  );
};

export const canAssignMozzoInternalUserRole = (accessRole, roleKey) =>
  listMozzoAssignableInternalUserRolesForAccessRole(accessRole).some(
    (role) => role.key === roleKey
  );

export const canViewMozzoPersonnelRole = (
  accessRole,
  roleKey,
  { isSelf = false } = {}
) => {
  if (
    [
      "creator",
      "platform_backoffice",
      "admin_general_global",
      "admin_general_branch",
    ].includes(accessRole)
  ) {
    return true;
  }

  if (isSelf) {
    return true;
  }

  return (VISIBLE_ROLE_KEYS_BY_ACCESS_ROLE[accessRole] || []).includes(roleKey);
};

export const getMozzoInternalUserRoleLabel = (roleKey) =>
  getMozzoInternalUserRole(roleKey)?.label || "Usuario interno";

export const getMozzoAccessRoleLabel = (accessRole) =>
  MOZZO_ACCESS_ROLE_DEFINITIONS.find((role) => role.key === accessRole)?.label ||
  "Usuario interno";

export const resolveMozzoInternalUserRoleKey = ({
  isOwner = false,
  role = "",
  workspaceRole = "",
} = {}) => {
  if (isOwner) {
    return "owner";
  }

  if (workspaceRole === "admin_general") {
    return "admin_general";
  }

  if (
    workspaceRole === "mozo" ||
    workspaceRole === "cocina" ||
    workspaceRole === "caja" ||
    workspaceRole === "soporte_mozzo" ||
    workspaceRole === "encargado_sucursal"
  ) {
    return workspaceRole;
  }

  if (role === "admin_general") {
    return "admin_general";
  }

  return "admin_limitado";
};

export const buildMozzoRoleBranchPermissions = (
  roleKey,
  customPermissions = null
) => {
  const roleDefinition = getMozzoInternalUserRole(roleKey);
  const basePermissions = roleDefinition?.branchPermissions || DEFAULT_LIMITED_ADMIN_BRANCH_PERMISSIONS;

  if (roleDefinition?.allowsCustomBranchPermissions) {
    return enforcePermissionDependencies(
      normalizeBooleanPermissions(customPermissions, basePermissions)
    );
  }

  return enforcePermissionDependencies(
    normalizeBooleanPermissions({}, basePermissions)
  );
};

export const canDelegateMozzoBranchPermission = (
  permissionKey,
  { canGrantAll = false, hasBranchPermission } = {}
) => {
  if (canGrantAll) {
    return true;
  }

  if (typeof hasBranchPermission !== "function") {
    return false;
  }

  if (permissionKey === "canViewMenu") {
    return (
      hasBranchPermission("canViewMenu") || hasBranchPermission("canManageMenu")
    );
  }

  if (permissionKey === "canViewStock") {
    return (
      hasBranchPermission("canViewStock") || hasBranchPermission("canManageStock")
    );
  }

  return hasBranchPermission(permissionKey);
};

export const buildDelegatedMozzoRoleBranchPermissions = (
  roleKey,
  requestedPermissions = {},
  delegationContext = {}
) => {
  const resolvedPermissions = buildMozzoRoleBranchPermissions(
    roleKey,
    requestedPermissions
  );
  const roleDefinition = getMozzoInternalUserRole(roleKey);

  if (!roleDefinition?.allowsCustomBranchPermissions) {
    return resolvedPermissions;
  }

  return enforcePermissionDependencies(
    MOZZO_BRANCH_PERMISSION_KEYS.reduce((permissions, permissionKey) => {
      permissions[permissionKey] =
        resolvedPermissions[permissionKey] === true &&
        canDelegateMozzoBranchPermission(permissionKey, delegationContext);
      return permissions;
    }, {})
  );
};

export const getMozzoInternalUserRoleModuleKeys = (
  roleKey,
  {
    branchPermissions = null,
    isKioskBranch = false,
  } = {}
) => {
  const resolvedRoleKey = resolveMozzoInternalUserRoleKey({
    workspaceRole: getMozzoInternalUserRole(roleKey)?.workspaceRole || roleKey,
  });

  if (
    resolvedRoleKey === "admin_limitado" ||
    resolvedRoleKey === "encargado_sucursal"
  ) {
    const resolvedPermissions = buildMozzoRoleBranchPermissions(
      resolvedRoleKey,
      branchPermissions
    );

    return getMozzoRoleModuleKeys(resolvedRoleKey, {
      hasBranchPermission: (permissionKey) =>
        resolvedPermissions?.[permissionKey] === true,
      isKioskBranch,
    });
  }

  if (resolvedRoleKey === "admin_general" || resolvedRoleKey === "owner") {
    return isKioskBranch
      ? GLOBAL_ADMIN_MODULE_KEYS.filter(
          (moduleKey) => moduleKey !== "mozos" && moduleKey !== "qr"
        )
      : [...GLOBAL_ADMIN_MODULE_KEYS];
  }

  const accessRole =
    resolvedRoleKey === "mozo"
      ? "mozo"
      : resolvedRoleKey === "cocina"
        ? "cocina"
        : resolvedRoleKey === "caja"
          ? "caja"
          : resolvedRoleKey === "soporte_mozzo"
            ? "soporte_mozzo"
            : "admin_limitado";

  return getMozzoRoleModuleKeys(accessRole, {
    hasBranchPermission: (permissionKey) =>
      buildMozzoRoleBranchPermissions(resolvedRoleKey, branchPermissions)?.[
        permissionKey
      ] === true,
    isKioskBranch,
  });
};

export const getMozzoRoleModuleKeys = (
  accessRole,
  {
    hasBranchPermission,
    isKioskBranch = false,
  } = {}
) => {
  switch (accessRole) {
    case "creator":
      return MOZZO_MODULE_DEFINITIONS.map((moduleDefinition) => moduleDefinition.key);
    case "platform_backoffice":
      return [...PLATFORM_BACKOFFICE_MODULE_KEYS];
    case "admin_general_global":
      return [...GLOBAL_ADMIN_MODULE_KEYS];
    case "admin_general_branch":
      return isKioskBranch
        ? BRANCH_ADMIN_GENERAL_MODULE_KEYS.filter(
            (moduleKey) => moduleKey !== "mozos" && moduleKey !== "qr"
          )
        : [...BRANCH_ADMIN_GENERAL_MODULE_KEYS];
    case "mozo":
      return [...WAITER_MODULE_KEYS];
    case "cocina":
      return [...KITCHEN_MODULE_KEYS];
    case "caja":
      return [...CASHIER_MODULE_KEYS];
    case "soporte_mozzo":
      return isKioskBranch
        ? SUPPORT_MODULE_KEYS.filter(
            (moduleKey) => moduleKey !== "mozos" && moduleKey !== "qr"
          )
        : [...SUPPORT_MODULE_KEYS];
    case "encargado_sucursal":
    case "admin_limitado":
    default: {
      const resolvedModuleKeys = Object.entries(branchPermissionChecksByModule)
        .filter(([, permissionKeys]) =>
          hasAnyBranchPermission(hasBranchPermission, permissionKeys)
        )
        .map(([moduleKey]) => moduleKey);

      const moduleKeysWithPersonnel = Array.from(
        new Set([...resolvedModuleKeys, ...LIMITED_ADMIN_BASE_MODULE_KEYS])
      );

      if (isKioskBranch) {
        return moduleKeysWithPersonnel.filter(
          (moduleKey) => moduleKey !== "mozos" && moduleKey !== "qr"
        );
      }

      return moduleKeysWithPersonnel;
    }
  }
};

export const resolveMozzoWorkspaceAccessRole = ({
  isCreatorMode = false,
  isPlatformBackofficeAdmin = false,
  isAdminGeneral = false,
  accessMode = "",
  branchSessionMode = "",
  currentCompany = null,
} = {}) => {
  if (isCreatorMode) {
    return "creator";
  }

  // El backoffice de plataforma no debe pisar el panel operativo del restaurante
  // cuando la sesion ya esta trabajando dentro de una empresa activa.
  if (
    isPlatformBackofficeAdmin &&
    accessMode !== "branch" &&
    !currentCompany?.id
  ) {
    return "platform_backoffice";
  }

  const workspaceRole = String(currentCompany?.workspaceRole || "").trim().toLowerCase();

  if (accessMode === "branch") {
    if (branchSessionMode === "mozo") {
      return "mozo";
    }

    if (branchSessionMode === "cocina") {
      return "cocina";
    }

    if (branchSessionMode === "admin" && (isAdminGeneral || workspaceRole === "admin_general")) {
      return "admin_general_branch";
    }

    if (workspaceRole === "encargado_sucursal") {
      return "encargado_sucursal";
    }

    if (workspaceRole === "caja") {
      return "caja";
    }

    if (workspaceRole === "soporte_mozzo") {
      return "soporte_mozzo";
    }

    return "admin_limitado";
  }

  if (
    isAdminGeneral ||
    currentCompany?.role === "admin_general" ||
    workspaceRole === "admin_general"
  ) {
    return "admin_general_global";
  }

  if (workspaceRole === "mozo") {
    return "mozo";
  }

  if (workspaceRole === "cocina") {
    return "cocina";
  }

  if (workspaceRole === "caja") {
    return "caja";
  }

  if (workspaceRole === "encargado_sucursal") {
    return "encargado_sucursal";
  }

  if (workspaceRole === "soporte_mozzo") {
    return "soporte_mozzo";
  }

  return "admin_limitado";
};

export const canAccessMozzoModule = (
  moduleKey,
  {
    isCreatorMode = false,
    isPlatformBackofficeAdmin = false,
    isWaiterWorkspace = false,
    isKitchenWorkspace = false,
    isAdminGeneral = false,
    accessMode = "",
    branchSessionMode = "",
    currentBranch = null,
    currentCompany = null,
    isKioskBranch = false,
    hasBranchPermission,
  } = {}
) => {
  if (!moduleKey) {
    return Boolean(currentBranch?.id);
  }

  if (moduleKey === "backoffice") {
    return isCreatorMode || isPlatformBackofficeAdmin;
  }

  if (isCreatorMode) {
    return true;
  }

  if (isWaiterWorkspace) {
    return moduleKey === "mozo";
  }

  if (isKitchenWorkspace) {
    return moduleKey === "cocina";
  }

  if (!currentBranch?.id) {
    if (moduleKey === "acceso") {
      return true;
    }

    return false;
  }

  if (isKioskBranch && (moduleKey === "mozos" || moduleKey === "qr")) {
    return false;
  }

  const accessRole = resolveMozzoWorkspaceAccessRole({
    isCreatorMode,
    isPlatformBackofficeAdmin,
    isAdminGeneral,
    accessMode,
    branchSessionMode,
    currentCompany,
  });

  const allowedModuleKeys = getMozzoRoleModuleKeys(accessRole, {
    hasBranchPermission,
    isKioskBranch,
  });

  return allowedModuleKeys.includes(moduleKey);
};

export const canManageMozzoInternalUsers = (accessRole) =>
  accessRole === "creator" ||
  accessRole === "platform_backoffice" ||
  accessRole === "admin_general_global" ||
  accessRole === "admin_general_branch";

export const canPerformMozzoAction = (
  actionKey,
  {
    accessRole = "",
    hasBranchPermission,
    hasWaiterPermission,
    isPlatformBackofficeAdmin = false,
  } = {}
) => {
  if (
    accessRole === "creator" ||
    accessRole === "platform_backoffice" ||
    isPlatformBackofficeAdmin
  ) {
    return true;
  }

  switch (actionKey) {
    case "apply_order_discount":
      return ["admin_general_global", "admin_general_branch"].includes(accessRole);
    case "manage_company_settings":
      return ["admin_general_global", "admin_general_branch"].includes(accessRole);
    case "manage_fiscal_connection":
      return ["admin_general_global", "admin_general_branch"].includes(accessRole);
    case "manage_users":
      return canManageMozzoInternalUsers(accessRole);
    case "view_personnel":
      return [
        "admin_general_global",
        "admin_general_branch",
        "encargado_sucursal",
        "admin_limitado",
      ].includes(accessRole);
    case "manage_personnel_directly":
    case "review_personnel_requests":
      return ["admin_general_global", "admin_general_branch"].includes(accessRole);
    case "request_personnel_changes":
      return ["encargado_sucursal", "admin_limitado"].includes(accessRole);
    case "toggle_operational_staff":
      return [
        "admin_general_global",
        "admin_general_branch",
        "encargado_sucursal",
        "admin_limitado",
      ].includes(accessRole);
    case "take_orders":
      if (accessRole === "mozo") {
        return typeof hasWaiterPermission === "function"
          ? hasWaiterPermission("takeOrders")
          : false;
      }
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageOrders")
        : false;
    case "modify_orders":
      if (accessRole === "mozo") {
        return typeof hasWaiterPermission === "function"
          ? hasWaiterPermission("modifyOrders")
          : false;
      }
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageOrders")
        : false;
    case "cancel_orders":
      if (accessRole === "mozo") {
        return typeof hasWaiterPermission === "function"
          ? hasWaiterPermission("cancelOrders")
          : false;
      }
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageOrders")
        : false;
    case "charge_orders":
      if (accessRole === "mozo") {
        return typeof hasWaiterPermission === "function"
          ? hasWaiterPermission("chargeOrders")
          : false;
      }
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManagePayments")
        : false;
    case "refund_orders":
      if (accessRole === "mozo") {
        return typeof hasWaiterPermission === "function"
          ? hasWaiterPermission("refundOrders")
          : false;
      }
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManagePayments")
        : false;
    case "view_external_orders":
    case "create_external_orders":
    case "edit_external_orders":
    case "cancel_external_orders":
    case "change_external_order_status":
    case "dispatch_external_order_to_kitchen":
    case "assign_external_delivery":
    case "view_customers":
    case "manage_customers":
    case "export_customers":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageOrders") ||
            hasBranchPermission("canManagePayments")
        : false;
    case "manage_delivery":
    case "manage_whatsapp":
    case "manage_sales_channels":
      if (["admin_general_global", "admin_general_branch"].includes(accessRole)) {
        return true;
      }

      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageSettings")
        : false;
    case "manage_menu":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageMenu")
        : false;
    case "manage_stock":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageStock")
        : false;
    case "manage_qr":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageQr")
        : false;
    case "manage_payments":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManagePayments")
        : false;
    case "export_reports":
      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageOrders") ||
            hasBranchPermission("canManagePayments") ||
            hasBranchPermission("canManageQr")
        : false;
    case "manage_settings":
      if (["admin_general_global", "admin_general_branch"].includes(accessRole)) {
        return true;
      }

      return typeof hasBranchPermission === "function"
        ? hasBranchPermission("canManageSettings")
        : false;
    default:
      return false;
  }
};

export const buildMozzoPermissionsSnapshot = (context = {}) => {
  const accessRole = resolveMozzoWorkspaceAccessRole(context);
  const moduleKeys = getMozzoRoleModuleKeys(accessRole, context);

  return {
    accessRole,
    moduleKeys,
    modules: MOZZO_MODULE_DEFINITIONS.map((moduleDefinition) => ({
      ...moduleDefinition,
      allowed: moduleKeys.includes(moduleDefinition.key),
    })),
  };
};
